export default "__VITE_ASSET__Dppd4FD6__"